import {UIGeneralServicesController} from '../../shared/scripts/UIGeneralServicesController.ts'
import {UINotificationActionController} from '../../shared/scripts/notifications/UINotificationActionController.ts'
import {UIMOnlineFriendController} from './ui_friends/UIMOnlineFriendController.ts'
import {type UIMManager} from './ui_html/UIMManager.ts'

export class UIMGeneralServicesController extends UIGeneralServicesController {
    constructor(uiManager: UIMManager | undefined) {
        super()

        const notificationPanelController = uiManager?.mainpageController.headerController.notificationPanelController

        this.onlineFriendController = new UIMOnlineFriendController(notificationPanelController)
        if(!notificationPanelController) return
        this.notificationActionController = new UINotificationActionController(notificationPanelController)
    }

    init() {
        this.onlineFriendController?.init()
    }
}
